import { initLocalStorage } from '@djs';

export const InstallSafariVariant = {
  Control: 'Control',
  Native: 'Native',
  NativeVideo: 'NativeVideo',
} as const;

export type InstallSafariVariant = Union<typeof InstallSafariVariant>;

const VARIANTS = Object.values(InstallSafariVariant);

interface InstallSafariAbTestState {
  variant: InstallSafariVariant | null;
}

const installSafariAbTestStorage = initLocalStorage<InstallSafariAbTestState>({ variant: null });

export async function pickInstallSafariVariant(): Promise<InstallSafariVariant> {
  await installSafariAbTestStorage.sync();

  const stored = installSafariAbTestStorage.get('variant');
  if (stored && VARIANTS.includes(stored)) return stored;

  const variant = VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
  installSafariAbTestStorage.set('variant', variant);
  return variant;
}
